(function () {
  if (window.__elegantContactFormPhoneValidation) return;
  window.__elegantContactFormPhoneValidation = true;

  var FORM_SELECTOR = ".site-contact-form";
  var PHONE_SELECTOR = 'input[name="contact[phone]"]';
  var SECTION_SELECTOR = "[data-contact-backup-endpoint]";
  var DEFAULT_BACKUP_ENDPOINT = "https://elegantlab-ups-shipping-labels.vercel.app/api/contact-lead";
  window.__elegantContactFormBackupVersion = "contact-lead-v2";
  var INVALID_MESSAGE = "Enter a valid 10-digit phone number";

  function normalizePhone(value) {
    var digits = (value || "").replace(/\D/g, "");

    if (digits.length === 11 && digits.charAt(0) === "1") {
      return digits.slice(1);
    }

    return digits;
  }

  function getPhoneInput(target) {
    if (!target || !(target instanceof HTMLElement)) return null;
    if (target.matches(PHONE_SELECTOR)) return target;
    return target.closest(PHONE_SELECTOR);
  }

  function setPhoneValidity(input, isInvalid) {
    input.classList.toggle("invalid", isInvalid);
    input.setAttribute("aria-invalid", isInvalid ? "true" : "false");
    input.setCustomValidity(isInvalid ? INVALID_MESSAGE : "");
  }

  function validatePhoneInput(input) {
    var value = (input.value || "").trim();

    if (!value) {
      setPhoneValidity(input, false);
      return true;
    }

    var digits = normalizePhone(value);
    var isValid = digits.length === 10;

    setPhoneValidity(input, !isValid);
    return isValid;
  }

  document.addEventListener("input", function (event) {
    var input = getPhoneInput(event.target);
    if (!input) return;

    if (!input.value.trim()) {
      setPhoneValidity(input, false);
      return;
    }

    input.classList.remove("invalid");
    input.setAttribute("aria-invalid", "false");
    input.setCustomValidity("");
  });

  document.addEventListener(
    "blur",
    function (event) {
      var input = getPhoneInput(event.target);
      if (!input) return;

      validatePhoneInput(input);
    },
    true
  );

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches(FORM_SELECTOR)) return;

      var phoneInput = form.querySelector(PHONE_SELECTOR);
      if (!phoneInput) return;

      if (!validatePhoneInput(phoneInput)) {
        event.preventDefault();
        phoneInput.focus();
        phoneInput.reportValidity();
        return;
      }

      if (typeof form.checkValidity === "function" && !form.checkValidity()) return;

      sendBackupLead(form);
    },
    true
  );

  function getFieldValue(form, name) {
    var field = form.elements.namedItem(name);
    if (!field) return "";

    if (field instanceof RadioNodeList) {
      return field.value || "";
    }

    if (field.type === "checkbox") {
      return field.checked ? field.value || "Yes" : "";
    }

    return field.value || "";
  }

  function getContactValue(form, name) {
    return getFieldValue(form, "contact[" + name + "]");
  }

  function getBackupEndpoint(form) {
    var section = form.closest(SECTION_SELECTOR);
    if (!section) return DEFAULT_BACKUP_ENDPOINT;
    if (section.dataset.contactBackupEnabled === "false") return "";

    return (section.dataset.contactBackupEndpoint || DEFAULT_BACKUP_ENDPOINT).trim();
  }

  function createBackupPayload(form) {
    return {
      firstName: getContactValue(form, "First Name"),
      lastName: getContactValue(form, "Last Name"),
      email: getContactValue(form, "email"),
      phone: getContactValue(form, "phone"),
      company: getContactValue(form, "Company/Practice Name"),
      stateRegion: getContactValue(form, "State/Region"),
      jobRole: getContactValue(form, "Job Role"),
      promoCode: getContactValue(form, "Promo Code"),
      feeSchedule: getContactValue(form, "Fee Schedule"),
      sourcePage: getContactValue(form, "Source Page"),
      sourceUrl: getContactValue(form, "Source URL") || window.location.href,
      body: getContactValue(form, "body"),
      website: getFieldValue(form, "website"),
      userAgent: window.navigator.userAgent,
      submittedAt: new Date().toISOString()
    };
  }

  function sendBackupLead(form) {
    var endpoint = getBackupEndpoint(form);
    if (!endpoint || form.dataset.contactBackupSent === "true") return;

    form.dataset.contactBackupSent = "true";

    var body = JSON.stringify(createBackupPayload(form));

    if (window.navigator && typeof window.navigator.sendBeacon === "function") {
      try {
        var blob = new Blob([body], { type: "text/plain;charset=UTF-8" });
        if (window.navigator.sendBeacon(endpoint, blob)) return;
      } catch (error) {
        // Fall back to fetch below; the Shopify contact submission should continue.
      }
    }

    window.fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "text/plain;charset=UTF-8"
      },
      body: body,
      keepalive: true,
      mode: "cors"
    }).catch(function () {
      // Backup delivery must never block the native Shopify contact form.
    });
  }

})();
